import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const policies = [
  {
    slug: "customer-privacy",
    title: "Customer Privacy Policy",
    subtitle: "Data Protection for Customers",
  },
  {
    slug: "customer-terms",
    title: "Customer Terms",
    subtitle: "Terms & Conditions for Customers",
  },
  {
    slug: "driver-privacy",
    title: "Driver Privacy Policy",
    subtitle: "Data Protection for Drivers",
  },
  {
    slug: "driver-terms",
    title: "Driver Terms",
    subtitle: "Terms & Conditions for Drivers",
  },
];

const faqs = [
  { label: "Driver FAQ", to: "/policies/driverfaqs" },
  { label: "Customer FAQ", to: "/policies/customerfaqs" },
];

export default function PoliciesHome() {
  return (
    <div className="py-16 px-6 md:px-10 bg-gray-50">

      {/* TITLE */}
      <h2 className="text-3xl font-bold text-center mb-10">
        Policies, Terms & Conditions
      </h2>

      {/* POLICIES */}
      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        {policies.map((p) => (
          <Link
            key={p.slug}
            to={`/policies/${p.slug}`}
            className="bg-white shadow-md rounded-lg p-6 hover:shadow-lg transition block"
          >
            <h3 className="font-semibold text-gray-800">{p.title}</h3>
            <p className="text-sm text-gray-500 mt-1">{p.subtitle}</p>

            <span className="text-orange-500 text-sm mt-3 flex items-center gap-1">
              Read
              <ArrowRight size={16} />
            </span>
          </Link>
        ))}
      </div>

      {/* FAQ BUTTONS*/}
      <div className="flex flex-wrap justify-center gap-3 mt-12">
        {faqs.map((f) => (
          <Link
            key={f.to}
            to={f.to}
            className="px-5 py-2 rounded-full border border-gray-300 text-green-700 
                       hover:bg-green-50 hover:border-green-400 transition text-sm"
          >
            {f.label}
          </Link>
        ))}
      </div>

    </div>
  );
}